import { render, staticRenderFns } from "./LwfFormSubmit.vue?vue&type=template&id=5c91d6e7&scoped=true&"
import script from "./LwfFormSubmit.vue?vue&type=script&lang=js&"
export * from "./LwfFormSubmit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c91d6e7",
  null
  
)

export default component.exports
import QPageSticky from 'quasar/src/components/page-sticky/QPageSticky.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import qInstall from "../../../node_modules/@quasar/app/lib/webpack/runtime.auto-import.js";
qInstall(component, 'components', {QPageSticky,QBtn});
